import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles((theme) => ({

  root: {

    position: "fixed",
    top: 0,
    right: 0,
    zIndex: "99999",
    width: '100vw',
    height: '100vh',
    // background: "linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1))"
  },
  spinner: {
    position: "absolute",
    left: "50%",
    top: "50%",
    color:"white"
  }
}));

export default function CircularIndeterminate({ loadCount }) {
  const classes = useStyles();
  return (
    loadCount>0
      ?
      <div className={classes.root} >
        <CircularProgress color="primary" className={classes.spinner} />
      </div> : null
  );
}